import React from "react";
import PropTypes from "prop-types";
import SortScore from "../SortScore";
const ThumbUp = ({ upDown }) => (
  <div className={upDown > 0 ? "thumbs-up" : upDown < 0 ? "thumbs-down" : ""}>
    {upDown > 0 || upDown < 0 ? ` ${Math.sqrt(Math.pow(upDown, 2))}` : ""}
  </div>
);
const CarouselAdmin = ({ space }) => {
  const bottomLeft = [
    "admin-viewport__bottom-left",
    space.limit_lock ? "alert--warning" : null,
  ]
    .filter((c) => c)
    .join(" ");
  // const bottomLeft = 'admin-viewport__bottom-left alert--warning'
  return (
    <div className="space-tile__admin-viewport">
      <SortScore space={space} />
      <div className="admin-viewport__venue-type">
        {(space.venue_type || ["No venue type"]).join(",")}
        <br />
        <em>{(space.space_type || ["No space type"]).join(",")}</em>
      </div>
      <div className="admin-viewport__data-cont">
        <div className="admin-viewport__top-left">
          {space.owner && space.owner.host_grade
            ? `${space.owner.host_grade}--${space.owner.account_manager} `
            : "No grade"}
        </div>
        <div className="admin-viewport__top-right">
          {space.sub_plan ? space.sub_plan : "No sub plan"}
        </div>
        <div className={bottomLeft}>
          {space.limit_lock
            ? "LOCKED"
            : space.venue_status === "HIDDEN"
            ? "HIDDEN"
            : space.owner
            ? "ACTIVE"
            : "INACTIVE"}
          &nbsp;
          <span title="Thread count">
            [{space.score ? space.score.thread_count || 0 : 0}]
          </span>
        </div>
        <div className="admin-viewport__bottom-right">
          {space.sub_expired}
          <ThumbUp upDown={space.admin && space.admin.thumbs} />
        </div>
      </div>
    </div>
  );
};

CarouselAdmin.propTypes = {
  space: PropTypes.object,
};

export default CarouselAdmin;
